import { getCurrencySymbol } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { Currency, PaymentInterval } from '@core/billing-types';
import { TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rt-plan-picker-2024-product-price',
  templateUrl: './plan-picker-2024-product-price.component.html',
  styleUrls: ['./plan-picker-2024-product-price.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class PlanPicker2024ProductPriceComponent {
  @Input() public interval: PaymentInterval;
  @Input() public currency: Currency;
  @Input() public costPerMonth: number;
  @Input() public costPerYear: number;

  public currencySymbol: string;
  public yearCost: string;
  public monthCost: string;

  public ngOnChanges() {
    this.currencySymbol = getCurrencySymbol(this.currency, 'narrow');
    this.yearCost = this.YearCost;
    this.monthCost = this.MonthCost;
  }

  private get YearCost() {
    return this.currencySymbol + Math.floor(this.costPerYear / 12);
  }

  private get MonthCost() {
    return this.currencySymbol + Math.floor(this.costPerMonth);
  }
}
